<div class="flex gap-2 items-center">
  <img
    src="icons/arrow_back_icon.svg"
    alt="back arrow"
    class="w-5 h-5 mt-1 cursor-pointer"
    (click)="goBack()"
  />
  <p
    class="text-th-black text-[16px] font-semibold underline underline-offset-4 cursor-pointer"
    (click)="goBack()"
  >
    Volver
  </p>
</div>
